<template>
  <div class="wrapper-div">
    <div id="titleAndSearch">
      <h1 class="title">{{$t('pages.gradebook.title')}}</h1>
      <div class="search">{{$t('pages.gradebook.search')}} <input id="query" name="query" v-model="searchQuery" @input="filterData()" /></div>
    </div>
    <div class="div-scroll">
      <table>
        <thead>
          <tr>
            <th v-for="(key, i) in columns" @click="sortBy(i)" :key="key + i" :class="{'Ime': (i === 0), 'Sum': (i === columnsLength)}" >
              <div v-if="i==columnsLength" class="Sum-div table-header">Σ</div>
              <div v-else-if="i!==0" class="table-header" @dblclick.stop.prevent="$refs.examResultsPreview.showCurrentResults(matrix.exams[i-1].id, 1)">{{ key }}</div>
              <div v-else class="Ime-div table-header">{{ $t('pages.gradebook.name') }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-observe-visibility="{callback: (isVisible, entry) => visibilityChanged(isVisible, entry, i), once:true}" v-for="i in gridDataVisible.length" :key="gridDataVisible[i - 1] + i.toString()"> <!-- vue starts from i = 1 -->
            <td v-for="j in (gridDataVisible[i - 1].length - 1)" :key="gridDataVisible[i - 1][j - 1] + j.toString()" :class="{'left-column': ((j - 1) === 0), 'table-light': (i - 1) % 2, 'table-white': i % 2, 'sum-column': (j - 1 === columnsLength)}">
              <div 
                class="table-divs"
                style="cursor: pointer;"
                @dblclick="goToUserProfile(i - 1, j - 1)"
                :class="{'left-column-div': ((j - 1) === 0), 'column-div': ((j - 1) !== 0 && gridDataVisible[i - 1][j - 1]!== null), 'column-div-green': ((j - 1)!==0 && gridDataVisible[i - 1][j]>=50), 'sum-column-div': ((j - 1) === columnsLength)}">
                  {{gridDataVisible[i - 1][j - 1]}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <exam-results-preview ref="examResultsPreview"/>
  </div>
</template>

<script>
// import { defineComponent } from '@vue/composition-api'
// import { mapGetters } from 'vuex'
import Rest from './../../../services/rest'
import ExamResultsPreview from '@/components/admin/group/ExamResultsPreview.vue'

export default {
  data () {
    return {
      matrix: {},
      title: 'Gradebook',
      nameLang: {sl: 'Ime', enus: 'Name'},
      columns: ['Ime'],
      gridData: [],
      gridDataCopy: [],
      gridDataVisible: [],
      numberOfVisibleRows: 0,
      numberOgRowsAdded: 30,
      columnsLength: 1,
      rowsLength: 0,
      sortOrder: [],
      searchQuery: '',
      groupNames: []
    }
  },
  props: {
    gid: '',
    yid: ''
  },
  components: {
    'exam-results-preview': ExamResultsPreview
  },
  methods: {
    resetRows () {
      this.numberOfVisibleRows = this.numberOgRowsAdded
      this.gridDataVisible = this.gridData.slice(0, this.numberOfVisibleRows)
    },
    goToUserProfile (i, j) {
      if (j === 0) {
        // open user profile
        this.$router.push({
          name: 'adminProfileGroupStats',
          params: {
            uid: this.gridData[i][this.columnsLength + 1].toString(),
            yearId: this.yid
          }
        })
      }
    },
    sortBy (i) {
      // sort by i-th colunm, maybe asc maybe desc depending on sortOrder
      this.gridData.sort((a, b) => {
        if (i === 0) {
          return a[0].localeCompare(b[0]) * this.sortOrder[i]
        } else {
          return (b[i] - a[i]) * this.sortOrder[i]
        }
      })
      this.sortOrder[i] *= -1
      this.resetRows()
    },
    filterData () {
      this.searchQuery = this.searchQuery.toString()
      if (this.searchQuery === '') {
        this.gridData = this.gridDataCopy
      } else {
        this.searchQuery = this.searchQuery.toLowerCase()
        this.gridData = this.gridDataCopy.filter((a) => {
          return a.some((b) => {
            if (b !== null) {
              b = b.toString()
              return (b.toLowerCase().indexOf(this.searchQuery) > -1)
            } else {
              return false
            }
          })
        })
        // console.log('Updated gridData je ', this.gridData)
      }
      this.resetRows()
    },
    init () {
      // this.columns[0] = this.$options.filters.pickTranslation(this.nameLang)
      this.columnsLength = 1 + this.matrix.exams.length
      this.rowsLength = this.matrix.grades.length
      for (let i = 1; i < this.columnsLength; i++) {
        this.columns[i] = this.matrix.exams[i - 1].title
      }
      this.columns[this.columnsLength] = 'sum'
      for (let i = 0; i < this.rowsLength; i++) {
        this.gridData[i] = []
        this.gridData[i][0] = this.matrix.grades[i].name
        this.gridData[i][this.columnsLength + 1] = this.matrix.grades[i].userId
        let sum = 0
        let count = 0
        for (let j = 1; j < this.columnsLength; j++) {
          this.gridData[i][j] = this.matrix.grades[i].grades[j - 1]
          sum += this.gridData[i][j]
          if (this.gridData[i][j] !== null) {
            count++
          }
        }
        if (count > 0) {
          this.gridData[i][this.columnsLength] = Math.round(sum / count)
        } else {
          this.gridData[i][this.columnsLength] = null
        }
      }
      this.gridDataCopy = JSON.parse(JSON.stringify(this.gridData))
      for (let i = 0; i <= this.columnsLength; i++) {
        this.sortOrder[i] = 1
      }
      this.resetRows()
    },
    restRequest () {
      Rest.request(`GET`, `/statistics/grades/year/` + this.yid).then((data) => {
        this.groupNames = data.names
        this.matrix = data
        this.addBreadcrumbsManually()
        this.init()
      })
    },
    addBreadcrumbsManually () {
      this.$store.state.subgroupsBreadcrumbs.push({
        groupId: this.gid,
        yearId: this.yid,
        subgroupId: 'root',
        name: {sl: this.groupNames.sl, enus: this.groupNames.enus}
      })
    },
    visibilityChanged (v, e, i) {
      if (v && i >= (this.numberOfVisibleRows - 10)) {
        this.numberOfVisibleRows = Math.min(this.numberOgRowsAdded + this.numberOfVisibleRows, this.gridData.length)
        for (let j = this.gridDataVisible.length; j < this.numberOfVisibleRows; j++) {
          this.gridDataVisible.push(this.gridData[j])
        }
      }
    }
  },
  mounted () {
    this.restRequest()
  }
}
</script>
<style scoped>
table {
  border: 1px;
  border-radius: 3px;
  table-layout: auto;
  width: 100%;
  overflow: auto;
}

.wrapper-div {
  height: 100%;
  width: 100%;
}

.div-scroll {
  overflow-x: scroll;
  overflow-y: scroll;
  max-height: 60vh;
}

th {
  background-color: #f6f6f6;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: sticky;
  top: 0;
  z-index: 2;
  height: 1px;
}

th, td {
  min-width: 120px;
}

td {
  position: relative;
  z-index: 0;
  height: 1px;
}

.table-divs {
  height: 100%;
  display: flex;
  align-items: center;
}
.table-light {
  background-color: #ffffff;
}

.table-white {
  background-color: #fafafc;
}

.left-column {
  position: sticky;
  z-index: 2;
  left: 0;
}

.sum-column {
  position: sticky;
  z-index: 2;
  right: 0;
}

.left-column-div {
  box-shadow: 0 5px 5px 0 lightgray;
  padding: 5px 20px;
}

.sum-column-div {
  box-shadow: 0 5px 5px 0 lightgray;
  padding: 5px 20px;
}

.table-header {
  box-shadow: 5px 0 5px 0 lightgray;
  padding: 5px 20px;
  height: 100%;
  display: flex;
  align-items: center;
}

.Ime {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
}

.Sum {
  position: sticky;
  right: 0;
  top: 0;
  z-index: 3;
}

.Ime-div {
  box-shadow: 0 0 5px 0 lightgray;
  padding: 5px 20px;
}

.column-div {
  padding: 5px 20px;
  color: #e34848;
}

.Sum-div {
  box-shadow: 0 0 5px 0 lightgray;
  padding: 5px 20px;
}

.column-div::after {
  content: ' %';
  height: fit-content;
}

.column-div-green {
  color: #4aa362;
}

#titleAndSearch {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 5px;
  padding: 5px;
}

.title {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// Gradebook.vue?3ca41852